// extracted by mini-css-extract-plugin
module.exports = {"submitted":"SubmittedInfo_submitted__2TwmF","label":"SubmittedInfo_label__1Nkg6","updatedAt":"SubmittedInfo_updatedAt__1GiHQ"};